<div class="main-cnt d-flex justify-content-center align-items-center vw-100 vh-100">
  <div class="overlay-bg"></div>
  <div class="text-center p-4 m-2 text-cnt">
    <h1>The page is temporarily unavailable.</h1>
    <p>We are working to correct the<br> issue, please check back soon.</p>
  </div>
</div>